import { AvvirRoutingEvent } from "type_aliases";
import type { BackContext } from "../../models/domain/back_context";

export type ToOrganizationSupportCenterPageEvent = AvvirRoutingEvent<typeof TO_ORGANIZATION_SUPPORT_CENTER_PAGE, { organizationId: string, backContext?: BackContext }>

const toOrganizationSupportCenterPage = (organizationId: string, backContext?: BackContext): ToOrganizationSupportCenterPageEvent => ({
  type: TO_ORGANIZATION_SUPPORT_CENTER_PAGE,
  payload: { organizationId, backContext }
});

export const TO_ORGANIZATION_SUPPORT_CENTER_PAGE = "to_organization_support_center_page";

export default toOrganizationSupportCenterPage;
